var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Accordion, AccordionDetails, AccordionSummary, Box, Chip, IconButton, Typography, useMediaQuery } from '@mui/material';
import dayjs from 'dayjs';
import { t } from 'i18next';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { v4 } from 'uuid';
import { futureAdviceDeleteURL, futureAdviceGetURL, futureAdviceUpsertURL } from '../../api/url';
import { ChevronRightIcon, ChevronUpIcon, TrashIconNew } from '../../assets/customIcons';
import { EditableDataGrid } from '../../builderPackage/components/editableDataGrid/editableDataGrid';
import { MuiButton, MuiStack } from '../../components';
import { MuiCheckBox } from '../../components/atoms/checkBox';
import { MuiLoaderButton } from '../../components/atoms/loaderButton';
import { showSurface } from '../../redux/awaitedSurfacesSlice';
import { setSavedTaskDetailsCount, setTaskDetailsDataSaved, showNotification } from '../../redux/commonSlice';
import { createAPI, getListAPI, setReducerState } from '../../redux/crudSlice';
import { useAppDispatch } from '../../store/hooks';
import { getLocalStorageItem } from '../../utils/storageHelper';
import { JobCardKeys } from '../jobCardDetails/services/entity';
import { fetchFutureAdviceTypes, fetchStatusByEntityId } from './apiCalls';
import FutureAdviseDetailPopup from './FutureAdviseDetailPopup';
var FutureAdviseGrid = function (_ref) {
    var _a = _ref.isDisabled, isDisabled = _a === void 0 ? false : _a, onSave = _ref.onSave, _b = _ref.documentId, documentId = _b === void 0 ? null : _b, _c = _ref.documentType, documentType = _c === void 0 ? 'Estimate' : _c, _d = _ref.documentData, documentData = _d === void 0 ? null : _d;
    var _e = useState([]), futureAdvise = _e[0], setFutureAdvise = _e[1];
    var _f = useState(false), isLoading = _f[0], setIsLoading = _f[1];
    var _g = useState(null), carriedForwardStatusId = _g[0], setCarriedForwardStatusId = _g[1];
    var UI_SETTINGS = getLocalStorageItem('ByChannelId');
    var _h = useState(false), isError = _h[0], setIsError = _h[1];
    var MaxAlloedtoCarryForwordSetting = UI_SETTINGS === null || UI_SETTINGS === void 0 ? void 0 : UI_SETTINGS.find(function (item) { return item.Key === "FA_Carried_Forward"; });
    var MaxAllowedFASetting = UI_SETTINGS === null || UI_SETTINGS === void 0 ? void 0 : UI_SETTINGS.find(function (item) { return item.Key === "Future_Advice_Count"; });
    var MaxAllowedFutureAdvise = MaxAllowedFASetting ? Number(MaxAllowedFASetting === null || MaxAllowedFASetting === void 0 ? void 0 : MaxAllowedFASetting.Value) : null;
    var MaxAllowedToCarryForward = MaxAlloedtoCarryForwordSetting ? Number(MaxAlloedtoCarryForwordSetting === null || MaxAlloedtoCarryForwordSetting === void 0 ? void 0 : MaxAlloedtoCarryForwordSetting.Value) : null;
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.only('xs'); });
    var updatedModuleSectionByChannel = useSelector(function (state) { return state.common; }).updatedModuleSectionByChannel;
    var savedFutureAdvice = useSelector(function (state) { return state.crud; }).savedFutureAdvice;
    var docType = documentType === 'ServiceEstimate' ? 'Estimate' : documentType;
    var dispatch = useAppDispatch();
    var activeFutureAdvises = useMemo(function () {
        return (futureAdvise === null || futureAdvise === void 0 ? void 0 : futureAdvise.filter(function (item) { return !item.IsDeleted; })) || [];
    }, [futureAdvise]);
    var carryForwardStatusName = 'Carried forward to next service';
    var getCarriedForwardCount = function (rows) {
        return rows.filter(function (item) { return !item.IsDeleted && item.StatusName === carryForwardStatusName; }).length;
    };
    var fetchFutureAdviseAPICall = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _res$payload, _res$payload2, res, savedAdvises, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: 'savedFutureAdvice',
                            url: futureAdviceGetURL,
                            request: {
                                InstallBaseId: documentData === null || documentData === void 0 ? void 0 : documentData.InstallBaseId,
                                DocumentId: documentId,
                                DocumentType: docType
                            }
                        }))];
                case 2:
                    res = _a.sent();
                    if (res !== null && res !== void 0 && (_res$payload = res.payload) !== null && _res$payload !== void 0 && (_res$payload = _res$payload.value) !== null && _res$payload !== void 0 && _res$payload.success && res !== null && res !== void 0 && (_res$payload2 = res.payload) !== null && _res$payload2 !== void 0 && (_res$payload2 = _res$payload2.value) !== null && _res$payload2 !== void 0 && _res$payload2.data) {
                        savedAdvises = res.payload.value.data.map(function (item) { return ({
                            id: item.id || item.FutureAdviceId,
                            FutureAdviceTypeId: item.FutureAdviceTypeId,
                            FutureAdviceTypeName: item.FutureAdviceTypeName || '',
                            SuggestionContent: item.SuggestionContent || '',
                            DueDate: item.DueDate ? new Date(item.DueDate) : null,
                            StatusId: item.StatusId,
                            StatusName: item.StatusName || '',
                            FutureAdviceId: item.FutureAdviceId,
                            IsDeleted: item.IsDeleted || false,
                            IsActive: item.IsActive !== false
                        }); });
                        dispatch(setSavedTaskDetailsCount({
                            futureAdviseCount: savedAdvises === null || savedAdvises === void 0 ? void 0 : savedAdvises.length
                        }));
                        setFutureAdvise(savedAdvises);
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    console.error('Error fetching future advises:', error_1);
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        var fetchDefaultStatus = function () { return __awaiter(void 0, void 0, void 0, function () {
            var statusResult, carriedForwardStatus;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchStatusByEntityId({})];
                    case 1:
                        statusResult = _a.sent();
                        if (statusResult !== null && statusResult !== void 0 && statusResult.success && statusResult !== null && statusResult !== void 0 && statusResult.data) {
                            carriedForwardStatus = statusResult.data.find(function (status) {
                                var _status$DisplayName;
                                return ((_status$DisplayName = status.DisplayName) === null || _status$DisplayName === void 0 ? void 0 : _status$DisplayName.toLowerCase()) === carryForwardStatusName.toLowerCase();
                            });
                            if (carriedForwardStatus) {
                                setCarriedForwardStatusId(carriedForwardStatus.id);
                            }
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        fetchDefaultStatus();
        if (documentId || documentData !== null && documentData !== void 0 && documentData.InstallBaseId)
            fetchFutureAdviseAPICall();
    }, [documentId, documentData === null || documentData === void 0 ? void 0 : documentData.InstallBaseId]);
    useEffect(function () {
        if (savedFutureAdvice !== null && savedFutureAdvice !== void 0 && savedFutureAdvice.data && Array.isArray(savedFutureAdvice.data)) {
            var savedAdvises = savedFutureAdvice.data.map(function (item) { return ({
                id: item.id || item.FutureAdviceId,
                FutureAdviceTypeId: item.FutureAdviceTypeId,
                FutureAdviceTypeName: item.FutureAdviceTypeName || '',
                SuggestionContent: item.SuggestionContent || '',
                DueDate: item.DueDate ? new Date(item.DueDate) : null,
                StatusId: item.StatusId,
                StatusName: item.StatusName || '',
                FutureAdviceId: item.FutureAdviceId,
                IsDeleted: item.IsDeleted || false,
                IsActive: item.IsActive !== false
            }); });
            dispatch(setSavedTaskDetailsCount({
                futureAdviseCount: savedAdvises === null || savedAdvises === void 0 ? void 0 : savedAdvises.length
            }));
            setFutureAdvise(savedAdvises);
        }
    }, [savedFutureAdvice]);
    var handleSectionSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _i, activeFutureAdvises_1, advise, carriedForwardCount, _res$payload3, _res$payload4, _res$payload5, payload, res, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if ((activeFutureAdvises === null || activeFutureAdvises === void 0 ? void 0 : activeFutureAdvises.length) === 0) {
                        dispatch(showNotification({
                            isOpen: true,
                            message: t('Please add at least one FA before saving.'),
                            type: 'error'
                        }));
                        return [2 /*return*/];
                    }
                    for (_i = 0, activeFutureAdvises_1 = activeFutureAdvises; _i < activeFutureAdvises_1.length; _i++) {
                        advise = activeFutureAdvises_1[_i];
                        if (!advise.SuggestionContent) {
                            dispatch(showNotification({
                                isOpen: true,
                                message: t("You\u2019ve added a future advice line. Please provide the details or remove the line to proceed."),
                                type: 'error'
                            }));
                            return [2 /*return*/];
                        }
                        if (!advise.DueDate) {
                            dispatch(showNotification({
                                isOpen: true,
                                message: t("Please enter a due date for the all Future Advice."),
                                type: 'error'
                            }));
                            return [2 /*return*/];
                        }
                        if (!advise.StatusId) {
                            dispatch(showNotification({
                                isOpen: true,
                                message: t("Status is required for all Future Advice."),
                                type: 'error'
                            }));
                            return [2 /*return*/];
                        }
                    }
                    if (MaxAllowedToCarryForward !== null) {
                        carriedForwardCount = getCarriedForwardCount(activeFutureAdvises);
                        if (carriedForwardCount > MaxAllowedToCarryForward) {
                            dispatch(showNotification({
                                isOpen: true,
                                message: t("Maximum allowed Future Advice with 'Carried Forward' status (".concat(MaxAllowedToCarryForward, ") has been reached. Please change status to proceed.")),
                                type: 'error'
                            }));
                            return [2 /*return*/];
                        }
                    }
                    setIsLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    payload = {
                        FutureAdviseList: activeFutureAdvises.map(function (s) { return ({
                            FutureAdviceId: s.FutureAdviceId || s.id,
                            SuggestionContent: s.SuggestionContent,
                            CustomerResponseId: s.CustomerResponseId,
                            FutureAdviceTypeId: s.FutureAdviceTypeId,
                            DueDate: s.DueDate,
                            StatusId: s.StatusId,
                            StatusName: s.StatusName,
                            IsGlobal: true
                        }); }),
                        InstallBaseId: documentData === null || documentData === void 0 ? void 0 : documentData.InstallBaseId,
                        ParentOrganizationId: documentData === null || documentData === void 0 ? void 0 : documentData.ParentOrganizationId,
                        OrganizationId: documentData === null || documentData === void 0 ? void 0 : documentData.OrganizationId,
                        RegistrationNo: documentData === null || documentData === void 0 ? void 0 : documentData.RegistrationNo,
                        VinNo: documentData === null || documentData === void 0 ? void 0 : documentData.VinNo,
                        DocumentId: documentId,
                        DocumentType: docType
                    };
                    return [4 /*yield*/, dispatch(createAPI({
                            key: 'upsertFutureAdvises',
                            url: futureAdviceUpsertURL,
                            request: payload
                        }))];
                case 2:
                    res = _a.sent();
                    dispatch(showNotification({
                        isOpen: true,
                        message: t(res !== null && res !== void 0 && (_res$payload3 = res.payload) !== null && _res$payload3 !== void 0 && (_res$payload3 = _res$payload3.value) !== null && _res$payload3 !== void 0 && _res$payload3.success ? 'Future advises saved successfully' : 'Failed to save future advises'),
                        type: res !== null && res !== void 0 && (_res$payload4 = res.payload) !== null && _res$payload4 !== void 0 && (_res$payload4 = _res$payload4.value) !== null && _res$payload4 !== void 0 && _res$payload4.success ? 'success' : 'error'
                    }));
                    if (res !== null && res !== void 0 && (_res$payload5 = res.payload) !== null && _res$payload5 !== void 0 && (_res$payload5 = _res$payload5.value) !== null && _res$payload5 !== void 0 && _res$payload5.success)
                        fetchFutureAdviseAPICall();
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _a.sent();
                    console.error('Error saving future advises:', error_2);
                    dispatch(showNotification({
                        isOpen: true,
                        message: t('Failed to save future advises'),
                        type: 'error'
                    }));
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoading(false);
                    dispatch(setTaskDetailsDataSaved(true));
                    dispatch(setSavedTaskDetailsCount({
                        futureAdviseCount: activeFutureAdvises === null || activeFutureAdvises === void 0 ? void 0 : activeFutureAdvises.length
                    }));
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleToolbarButtonClick = function (e, params) { return __awaiter(void 0, void 0, void 0, function () {
        var _params$api, selectedRows_1, selectedItems, deleteResults, successfulIds_1, failedCount, _updatedFutureAdvises, updatedFutureAdvises, carriedForwardCount;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(e.currentTarget.id === 'delete')) return [3 /*break*/, 2];
                    selectedRows_1 = params === null || params === void 0 || (_params$api = params.api) === null || _params$api === void 0 || (_params$api = _params$api.current) === null || _params$api === void 0 ? void 0 : _params$api.getSelectedRows();
                    selectedItems = futureAdvise.filter(function (item) { return selectedRows_1 === null || selectedRows_1 === void 0 ? void 0 : selectedRows_1.has(item.id); });
                    return [4 /*yield*/, Promise.all(selectedItems.map(function (item) { return __awaiter(void 0, void 0, void 0, function () {
                            var _ref2, _res$payload$success, _res$payload6, _res$payload7, res;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!(item !== null && item !== void 0 && item.FutureAdviceId)) return [3 /*break*/, 2];
                                        return [4 /*yield*/, dispatch(createAPI({
                                                key: 'delete',
                                                url: futureAdviceDeleteURL,
                                                request: {
                                                    IsDeleted: true,
                                                    IsActive: false,
                                                    FutureAdviceId: item === null || item === void 0 ? void 0 : item.FutureAdviceId
                                                }
                                            }))];
                                    case 1:
                                        res = _a.sent();
                                        return [2 /*return*/, {
                                                id: item.id,
                                                success: (_ref2 = (_res$payload$success = res === null || res === void 0 || (_res$payload6 = res.payload) === null || _res$payload6 === void 0 ? void 0 : _res$payload6.success) !== null && _res$payload$success !== void 0 ? _res$payload$success : res === null || res === void 0 || (_res$payload7 = res.payload) === null || _res$payload7 === void 0 || (_res$payload7 = _res$payload7.value) === null || _res$payload7 === void 0 ? void 0 : _res$payload7.success) !== null && _ref2 !== void 0 ? _ref2 : false
                                            }];
                                    case 2: 
                                    // New unsaved rows can be deleted without API call
                                    return [2 /*return*/, {
                                            id: item.id,
                                            success: true
                                        }];
                                }
                            });
                        }); }))];
                case 1:
                    deleteResults = _a.sent();
                    successfulIds_1 = new Set(deleteResults.filter(function (r) { return r.success; }).map(function (r) { return r.id; }));
                    failedCount = deleteResults.filter(function (r) { return !r.success; }).length;
                    if (failedCount > 0) {
                        dispatch(showNotification({
                            isOpen: true,
                            message: t('Some Future Advices cannot be deleted as they are carried forward from the previous Job Card.'),
                            type: 'error'
                        }));
                    }
                    if (successfulIds_1.size > 0) {
                        updatedFutureAdvises = futureAdvise.map(function (item) { return successfulIds_1.has(item.id) ? _objectSpread(_objectSpread({}, item), {}, {
                            IsDeleted: true,
                            IsActive: false
                        }) : item; });
                        setFutureAdvise(updatedFutureAdvises);
                        dispatch(setSavedTaskDetailsCount({
                            futureAdviseCount: (updatedFutureAdvises === null || updatedFutureAdvises === void 0 || (_updatedFutureAdvises = updatedFutureAdvises.filter(function (item) { return !item.IsDeleted; })) === null || _updatedFutureAdvises === void 0 ? void 0 : _updatedFutureAdvises.length) || 0
                        }));
                        onSave === null || onSave === void 0 || onSave(updatedFutureAdvises);
                    }
                    return [2 /*return*/, false];
                case 2:
                    if (e.currentTarget.id === 'add') {
                        if (MaxAllowedToCarryForward !== null) {
                            carriedForwardCount = getCarriedForwardCount(activeFutureAdvises);
                            if (carriedForwardCount >= MaxAllowedToCarryForward) {
                                dispatch(showNotification({
                                    isOpen: true,
                                    message: t("Maximum allowed Future Advice with 'Carried Forward' status (".concat(MaxAllowedToCarryForward, ") has been reached. Please change status to proceed.")),
                                    type: 'error'
                                }));
                                return [2 /*return*/, false];
                            }
                        }
                        if (MaxAllowedFutureAdvise !== null && activeFutureAdvises.length >= MaxAllowedFutureAdvise) {
                            dispatch(showNotification({
                                isOpen: true,
                                message: t("Maximum allowed Future Advice count (".concat(MaxAllowedFutureAdvise, ") has been reached.")),
                                type: 'error'
                            }));
                            return [2 /*return*/, false];
                        }
                    }
                    return [2 /*return*/, true];
            }
        });
    }); };
    var columns = [{
            type: 'searchSelect',
            field: 'FutureAdviceTypeName',
            headerName: 'FA type',
            minWidth: 250,
            editable: !isDisabled,
            getListData: fetchFutureAdviceTypes,
            valueSetter: function (value, row) {
                var _value$Name, _value$id;
                if (!value) {
                    return _objectSpread(_objectSpread({}, row), {}, {
                        DueDate: null,
                        StatusId: null,
                        StatusName: null,
                        SuggestionContent: null,
                        FutureAdviceTypeName: null,
                        FutureAdviceTypeId: null
                    });
                }
                return _objectSpread(_objectSpread({}, row), {}, {
                    FutureAdviceTypeName: (_value$Name = value === null || value === void 0 ? void 0 : value.Name) !== null && _value$Name !== void 0 ? _value$Name : '',
                    FutureAdviceTypeId: (_value$id = value === null || value === void 0 ? void 0 : value.id) !== null && _value$id !== void 0 ? _value$id : null
                });
            },
            valueGetter: function (val, row) {
                var _row$FutureAdviceType, _row$FutureAdviceType2, _row$FutureAdviceType3, _row$FutureAdviceType4;
                return {
                    Name: (_row$FutureAdviceType = row === null || row === void 0 ? void 0 : row.FutureAdviceTypeName) !== null && _row$FutureAdviceType !== void 0 ? _row$FutureAdviceType : '',
                    FutureAdviceTypeName: (_row$FutureAdviceType2 = row === null || row === void 0 ? void 0 : row.FutureAdviceTypeName) !== null && _row$FutureAdviceType2 !== void 0 ? _row$FutureAdviceType2 : '',
                    FutureAdviceTypeId: (_row$FutureAdviceType3 = row === null || row === void 0 ? void 0 : row.FutureAdviceTypeId) !== null && _row$FutureAdviceType3 !== void 0 ? _row$FutureAdviceType3 : null,
                    id: (_row$FutureAdviceType4 = row === null || row === void 0 ? void 0 : row.FutureAdviceTypeId) !== null && _row$FutureAdviceType4 !== void 0 ? _row$FutureAdviceType4 : null
                };
            },
            valueFormatter: function (value) { return (value === null || value === void 0 ? void 0 : value.Name) || ''; },
            getOptionLabel: function (option) { return option.Name; }
        }, {
            type: 'string',
            field: 'SuggestionContent',
            headerName: 'Future advise details',
            flex: 1,
            minWidth: 300,
            editable: !isDisabled,
            placeholder: 'Enter remarks'
        }, {
            type: 'date',
            field: 'DueDate',
            headerName: 'Due date',
            minWidth: 180,
            editable: !isDisabled,
            valueFormatter: function (value) { return value ? dayjs(value).format('DD MMM, YYYY') : ''; }
        }, {
            type: 'searchSelect',
            field: 'StatusId',
            headerName: 'Status',
            minWidth: 320,
            editable: !isDisabled,
            getListData: fetchStatusByEntityId,
            valueGetter: function (val, row) {
                var _row$StatusName, _row$StatusId, _row$StatusName2;
                return {
                    DisplayName: (_row$StatusName = row === null || row === void 0 ? void 0 : row.StatusName) !== null && _row$StatusName !== void 0 ? _row$StatusName : '',
                    id: (_row$StatusId = row === null || row === void 0 ? void 0 : row.StatusId) !== null && _row$StatusId !== void 0 ? _row$StatusId : null,
                    StatusName: (_row$StatusName2 = row === null || row === void 0 ? void 0 : row.StatusName) !== null && _row$StatusName2 !== void 0 ? _row$StatusName2 : ''
                };
            },
            valueSetter: function (value, row) {
                var _value$id2, _value$DisplayName;
                return _objectSpread(_objectSpread({}, row), {}, {
                    StatusId: (_value$id2 = value === null || value === void 0 ? void 0 : value.id) !== null && _value$id2 !== void 0 ? _value$id2 : null,
                    StatusName: (_value$DisplayName = value === null || value === void 0 ? void 0 : value.DisplayName) !== null && _value$DisplayName !== void 0 ? _value$DisplayName : ''
                });
            },
            getOptionLabel: function (option) { return (option === null || option === void 0 ? void 0 : option.DisplayName) || ''; },
            valueFormatter: function (value) { return (value === null || value === void 0 ? void 0 : value.DisplayName) || ''; }
        }];
    var AddFABtn = function () {
        return /*#__PURE__*/ React.createElement(MuiButton, {
            disabled: isDisabled,
            variant: "text",
            name: "+ ".concat(t('Add')),
            size: "small",
            onClick: function () {
                if (MaxAllowedToCarryForward !== null) {
                    var carriedForwardCount = getCarriedForwardCount(activeFutureAdvises);
                    if (carriedForwardCount >= MaxAllowedToCarryForward) {
                        dispatch(showNotification({
                            isOpen: true,
                            message: t("Maximum allowed Future Advice with 'Carried Forward' status (".concat(MaxAllowedToCarryForward, ") has been reached. Please change status to proceed.")),
                            type: 'error'
                        }));
                        return;
                    }
                }
                if (MaxAllowedFutureAdvise !== null && activeFutureAdvises.length >= MaxAllowedFutureAdvise) {
                    dispatch(showNotification({
                        isOpen: true,
                        message: t("Maximum allowed Future Advice count (".concat(MaxAllowedFutureAdvise, ") has been reached.")),
                        type: 'error'
                    }));
                    return;
                }
                var newRow = {
                    id: v4(),
                    FutureAdviceTypeId: '',
                    SuggestionContent: '',
                    DueDate: null,
                    StatusId: carriedForwardStatusId || '',
                    StatusName: carriedForwardStatusId ? carryForwardStatusName : '',
                    IsActive: true,
                    IsDeleted: false
                };
                var newRows = __spreadArray(__spreadArray([], futureAdvise, true), [newRow], false);
                setFutureAdvise(newRows);
                onSave === null || onSave === void 0 || onSave(newRows);
            },
            id: "add-fa-btn"
        });
    };
    var FAList = function () {
        return /*#__PURE__*/ React.createElement(MuiStack, {
            direction: "column"
        }, activeFutureAdvises.length === 0 ? /*#__PURE__*/ React.createElement(MuiStack, {
            alignItems: "center",
            justifyContent: "center",
            padding: 4
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "body2",
            color: "textSecondary"
        }, t('No future advice added.'))) : activeFutureAdvises.map(function (item) { /*#__PURE__*/ return React.createElement(MuiStack, {
            key: item.id,
            direction: "row",
            alignItems: "center",
            justifyContent: "space-between",
            sx: {
                px: 2,
                py: 1.5,
                borderTop: '1px solid',
                borderColor: 'secondary.200'
            }
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            direction: "row",
            spacing: 1,
            alignItems: "center"
        }, /*#__PURE__*/ React.createElement(MuiCheckBox, {
            checkBoxValue: item.isSelected,
            handleChange: function (e) {
                setFutureAdvise(function (prev) { return prev.map(function (fa) { return fa.id === item.id ? _objectSpread(_objectSpread({}, fa), {}, {
                    isSelected: !fa.isSelected
                }) : fa; }); });
            },
            sx: {
                "& .MuiCheckbox-root": {
                    padding: 0
                }
            },
            disabled: isDisabled !== null && isDisabled !== void 0 ? isDisabled : false,
            style: {
                opacity: isDisabled ? 0.7 : 1
            }
        }), /*#__PURE__*/ React.createElement(Typography, {
            variant: "body1",
            sx: {
                flex: 1,
                wordBreak: 'break-word'
            }
        }, item.SuggestionContent || t('Future advice'))), /*#__PURE__*/ React.createElement(IconButton, {
            size: "small",
            onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, dispatch(showSurface({
                                type: 'Drawer',
                                Component: FutureAdviseDetailPopup,
                                containerProps: {
                                    anchor: 'bottom',
                                    PaperProps: {
                                        sx: {
                                            borderRadius: '12px 12px 0 0'
                                        }
                                    }
                                },
                                componentProps: {
                                    data: item,
                                    isDisabled: isDisabled,
                                    onUpdate: function (updatedItem) {
                                        var updatedRows = futureAdvise.map(function (row) { return row.id === updatedItem.id ? _objectSpread(_objectSpread({}, row), updatedItem) : row; });
                                        setFutureAdvise(updatedRows);
                                        onSave === null || onSave === void 0 || onSave(updatedRows);
                                    }
                                }
                            }))];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); }
        }, /*#__PURE__*/ React.createElement(ChevronRightIcon, {
            sx: {
                color: 'primary.main'
            }
        }))); }));
    };
    var handleDisableSaveButton = function (value) {
        setIsError(value);
        dispatch(setReducerState({
            key: JobCardKeys.DisableSubmit,
            value: value
        }));
    };
    var handleDelete = function () { return __awaiter(void 0, void 0, void 0, function () {
        var selectedItems, deleteResults, successfulIds, failedCount, _updatedFutureAdvises2, updatedFutureAdvises;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    selectedItems = futureAdvise.filter(function (item) { return item.isSelected; });
                    return [4 /*yield*/, Promise.all(selectedItems.map(function (item) { return __awaiter(void 0, void 0, void 0, function () {
                            var _ref3, _res$payload$success2, _res$payload8, _res$payload9, res;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!(item !== null && item !== void 0 && item.FutureAdviceId)) return [3 /*break*/, 2];
                                        return [4 /*yield*/, dispatch(createAPI({
                                                key: 'delete',
                                                url: futureAdviceDeleteURL,
                                                request: {
                                                    IsDeleted: true,
                                                    IsActive: false,
                                                    FutureAdviceId: item === null || item === void 0 ? void 0 : item.FutureAdviceId
                                                }
                                            }))];
                                    case 1:
                                        res = _a.sent();
                                        return [2 /*return*/, {
                                                id: item.id,
                                                success: (_ref3 = (_res$payload$success2 = res === null || res === void 0 || (_res$payload8 = res.payload) === null || _res$payload8 === void 0 ? void 0 : _res$payload8.success) !== null && _res$payload$success2 !== void 0 ? _res$payload$success2 : res === null || res === void 0 || (_res$payload9 = res.payload) === null || _res$payload9 === void 0 || (_res$payload9 = _res$payload9.value) === null || _res$payload9 === void 0 ? void 0 : _res$payload9.success) !== null && _ref3 !== void 0 ? _ref3 : false
                                            }];
                                    case 2: return [2 /*return*/, {
                                            id: item.id,
                                            success: true
                                        }];
                                }
                            });
                        }); }))];
                case 1:
                    deleteResults = _a.sent();
                    successfulIds = new Set(deleteResults.filter(function (r) { return r.success; }).map(function (r) { return r.id; }));
                    failedCount = deleteResults.filter(function (r) { return !r.success; }).length;
                    if (failedCount > 0) {
                        dispatch(showNotification({
                            isOpen: true,
                            message: t('Future Advice carried forward from a previous Job Card cannot be deleted.'),
                            type: 'error'
                        }));
                    }
                    if (successfulIds.size > 0) {
                        updatedFutureAdvises = futureAdvise.map(function (item) { return successfulIds.has(item.id) ? _objectSpread(_objectSpread({}, item), {}, {
                            IsDeleted: true,
                            IsActive: false
                        }) : item; });
                        setFutureAdvise(updatedFutureAdvises);
                        dispatch(setSavedTaskDetailsCount({
                            futureAdviseCount: (updatedFutureAdvises === null || updatedFutureAdvises === void 0 || (_updatedFutureAdvises2 = updatedFutureAdvises.filter(function (item) { return !item.IsDeleted; })) === null || _updatedFutureAdvises2 === void 0 ? void 0 : _updatedFutureAdvises2.length) || 0
                        }));
                        onSave === null || onSave === void 0 || onSave(updatedFutureAdvises);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return /*#__PURE__*/ React.createElement(Box, {
        sx: {
            width: '100%'
        }
    }, !isMobile ? /*#__PURE__*/ React.createElement(EditableDataGrid, {
        columns: columns,
        dataGridHeader: docType === 'JobCard' && !isDisabled ? t('Future Advice') : null,
        validationModel: {
            FutureAdviceTypeName: function (value, row) {
                return '';
            },
            SuggestionContent: function (value, row) {
                if (!(row !== null && row !== void 0 && row.FutureAdviceTypeId)) {
                    handleDisableSaveButton(false);
                    return '';
                }
                if (!value) {
                    handleDisableSaveButton(true);
                    return "You\u2019ve added a future advice line. Please provide the details or remove the line to proceed";
                }
                if (value.length > 1000) {
                    handleDisableSaveButton(true);
                    return 'Future Advice Details cannot exceed 1000 characters.';
                }
                handleDisableSaveButton(false);
                return '';
            },
            DueDate: function (value, row) {
                if (!(row !== null && row !== void 0 && row.FutureAdviceTypeId)) {
                    handleDisableSaveButton(false);
                    return undefined;
                }
                if (!value) {
                    handleDisableSaveButton(true);
                    return "Please enter a due date for the all Future Advice.";
                }
                var today = dayjs().startOf('day');
                var selectedDate = dayjs(value).startOf('day');
                if (selectedDate.isBefore(today)) {
                    handleDisableSaveButton(true);
                    return 'Past due date is not allowed. Please select present or future date.';
                }
                handleDisableSaveButton(false);
                return '';
            },
            StatusId: function (value, row) {
                if (!(row !== null && row !== void 0 && row.FutureAdviceTypeId)) {
                    handleDisableSaveButton(false);
                    return '';
                }
                if (!value) {
                    handleDisableSaveButton(true);
                    return 'Status is required.';
                }
                handleDisableSaveButton(false);
                return '';
            }
        },
        disableAddRow: isDisabled,
        rows: activeFutureAdvises,
        onChange: function (e, updatedRows, details) {
            if (updatedRows) {
                var rowsWithDefaults = updatedRows.map(function (row) {
                    if (!row.StatusId && carriedForwardStatusId) {
                        return _objectSpread(_objectSpread({}, row), {}, {
                            StatusId: carriedForwardStatusId,
                            StatusName: carryForwardStatusName
                        });
                    }
                    return row;
                });
                // if (MaxAllowedToCarryForward !== null) {
                //     const carriedForwardCount = getCarriedForwardCount(rowsWithDefaults);
                //     if (carriedForwardCount > MaxAllowedToCarryForward) {
                //         dispatch(showNotification({
                //             isOpen: true,
                //             message: t(`Maximum allowed Future Advice with 'Carried Forward' status (${MaxAllowedToCarryForward}) has been reached. Please change status to proceed.`),
                //             type: 'error',
                //         }));
                //         return;
                //     }
                // }
                setFutureAdvise(rowsWithDefaults);
                onSave === null || onSave === void 0 || onSave(rowsWithDefaults);
            }
        },
        isCollapsible: false,
        disableDeleteRow: isDisabled,
        dataGridProps: {
            checkboxSelection: !isDisabled,
            disableRowSelectionOnClick: true,
            hideFooter: true,
            isCellEditable: function (params) {
                var _params$row;
                if (params.field === 'FutureAdviceTypeName') {
                    return true;
                }
                return !!((_params$row = params.row) !== null && _params$row !== void 0 && _params$row.FutureAdviceTypeId);
            },
            slotProps: {
                toolbar: {
                    chipLabel: docType === 'JobCard' && !isDisabled ? activeFutureAdvises === null || activeFutureAdvises === void 0 ? void 0 : activeFutureAdvises.length : undefined
                }
            }
        },
        onToolbarButtonClick: handleToolbarButtonClick
    }) : /*#__PURE__*/ React.createElement(React.Fragment, null, docType === "JobCard" ? /*#__PURE__*/ React.createElement(Accordion, {
        defaultExpanded: true,
        disableGutters: true,
        elevation: 0,
        sx: {
            border: '1px solid',
            borderColor: 'secondary.200',
            borderRadius: '8px !important',
            '&:before': {
                display: 'none'
            },
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ React.createElement(AccordionSummary, {
        expandIcon: /*#__PURE__*/ React.createElement(ChevronUpIcon, {
            sx: {
                color: 'secondary.600'
            }
        }),
        sx: {
            bgcolor: 'white',
            px: 2,
            '& .MuiAccordionSummary-content': {
                alignItems: 'center',
                margin: 0,
                gap: 1
            }
        }
    }, docType === "JobCard" && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
        fontWeight: 'strong'
    }, t('Future advice')), /*#__PURE__*/ React.createElement(Chip, {
        size: "small",
        variant: "outlined",
        color: "info",
        label: activeFutureAdvises.length
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "row",
        flex: 1,
        justifyContent: "flex-end",
        spacing: 1,
        onClick: function (e) { return e.stopPropagation(); }
    }, !isDisabled && /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%',
        padding: 1,
        direction: "row",
        alignItems: "center",
        justifyContent: "flex-end"
    }, /*#__PURE__*/ React.createElement(AddFABtn, null), /*#__PURE__*/ React.createElement(IconButton, {
        onClick: function () { return handleDelete(); },
        size: "small"
    }, /*#__PURE__*/ React.createElement(TrashIconNew, null))))), /*#__PURE__*/ React.createElement(AccordionDetails, {
        sx: {
            p: 0
        }
    }, /*#__PURE__*/ React.createElement(FAList, null))) : /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        spacing: 0,
        sx: {
            background: '#fff',
            borderRadius: '8px'
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%',
        spacing: 1,
        padding: 1,
        direction: "row",
        alignItems: "center",
        justifyContent: "flex-end"
    }, /*#__PURE__*/ React.createElement(AddFABtn, null), /*#__PURE__*/ React.createElement(IconButton, {
        disabled: isDisabled,
        onClick: function () { return handleDelete(); },
        size: "small"
    }, /*#__PURE__*/ React.createElement(TrashIconNew, null))), /*#__PURE__*/ React.createElement(FAList, null))), docType !== "JobCard" && activeFutureAdvises.length > 0 && !isDisabled && /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "row",
        justifyContent: "flex-end",
        paddingTop: 2
    }, /*#__PURE__*/ React.createElement(MuiLoaderButton, {
        variant: "outlined",
        name: t('Save'),
        size: "medium",
        loading: isLoading,
        onClick: handleSectionSave,
        disabled: activeFutureAdvises.length === 0 || isError,
        id: "section-save-FutureAdvise-btn"
    })));
};
export default FutureAdviseGrid;
